<app-nav-admin--menu></app-nav-admin--menu>

<div class="configContent">
<h1 class="configTitle">Filing Routes</h1>

<table class="table">
  <thead>
    <tr>
      <th class="filingNumber" scope="col">#</th>
      <th class="filingRoute" scope="col">Filing Route</th>
      <th class="filingDescription" scope="col">Description</th>
      <th class="filingActions" scope="col">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let filingRoute of filingRoutes; index as i">
      <td class="numberColumn">{{i + 1}}</td>
      <td class="nameColumn">{{filingRoute.name}}</td>
      <td class="descriptionColumn">{{filingRoute.descriptionText}}</td>
      <td class="actionColumn">
        <button mat-icon-button (click)="editFilingRoute(i)"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button (click)="deleteFilingRoute(i)"><mat-icon>delete</mat-icon></button>
      </td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td class="addFiling">
        <button mat-icon-button (click)="addFilingRoute()"><mat-icon>add</mat-icon></button>
      </td>
    </tr>
  </tbody>
</table>

<hr />

<div class="mb-5">
  <button mat-raised-button class="me-2" (click)="save()" [disabled]="!dirty">Save</button>
  <button mat-raised-button (click)="discard()" [disabled]="!dirty">Discard Changes</button>
</div>
  </div>
<footer>
  <patempoFooter></patempoFooter>
</footer>
